import { addEventToMediaQuery, removeEventFromMediaQuery } from './mediaQueryEvents';

declare interface ViewPort {
  desktop: boolean | null;
  mobile: boolean | null;
  mediaQuery: string;
}

const viewPortSingleton: ViewPort = {
  desktop: null,
  mobile: null,
  mediaQuery: '(min-width: 1025px)',
};

const setViewPort = (query: Pick<MediaQueryList, 'matches'>) => {
  viewPortSingleton.desktop = query.matches;
  viewPortSingleton.mobile = !viewPortSingleton.desktop;
};

const desktopMediaQueryList = window.matchMedia('(min-width: 1025px)');
setViewPort(desktopMediaQueryList);

const viewPortChangeListener = ({ matches }: MediaQueryListEvent) => setViewPort({ matches });
addEventToMediaQuery(viewPortChangeListener, desktopMediaQueryList);

export function getViewPort() {
  return viewPortSingleton;
}

export function listenViewPort(listener: (event: MediaQueryListEvent) => void) {
  addEventToMediaQuery(listener, desktopMediaQueryList);
  return () => {
    removeEventFromMediaQuery(listener, desktopMediaQueryList);
  };
}
